import { useRef } from "react";
import OpdIcon from "./OpdIcon";
import { DownloadPngButton } from "./primitives";

const ClaimsDataTable = ({ title, columns = [], rows = [], loading = false }) => {
  const skeletonRows = 5;
  const cardRef = useRef(null);

  // Map column types to Tailwind text colors & font
  const getCellClass = (col) => {
    const lowerCol = col.toLowerCase();
    if (lowerCol.includes("name")) return "font-fig-semibold text-gray-900";
    if (lowerCol.includes("cashless")) return "font-jetbrains-mono tabular-nums text-green-700";
    if (lowerCol.includes("reimbursement")) return "font-jetbrains-mono tabular-nums text-blue-700";
    if (lowerCol.includes("value") || lowerCol.includes("amount") || lowerCol.includes("count")) return "font-jetbrains-mono font-fig-semibold tabular-nums text-gray-900";
    return "font-fig-normal text-gray-700";
  };

  return (
    <div ref={cardRef} className="mb-6 flex flex-col gap-3">
      <div className="mb-4 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <h2 className="mb-0 flex items-center gap-2 text-lg font-fig-semibold leading-tight text-gray-900">
          <OpdIcon name="table" className="h-6 w-6 rounded border border-blue-200 bg-blue-100 p-1.5 text-blue-700" />
          <span>{title}</span>
          <DownloadPngButton nodeRef={cardRef} fileName={(title || 'table').toLowerCase().replace(/[^a-z0-9]+/g, '-')} />
        </h2>
      </div>
      <div className="overflow-x-auto rounded-lg border border-gray-300 bg-white">
        <table className="w-full table-auto border-collapse text-left text-xs">
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th
                  key={idx}
                  className="relative border-b border-gray-300 bg-gray-50 px-4 py-2.5 text-left text-2xs font-bold uppercase tracking-widest text-gray-600"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading
              ? Array.from({ length: skeletonRows }).map((_, idx) => (
                <tr key={idx} className="animate-pulse bg-gray-50">
                  {columns.map((_, cIdx) => (
                    <td key={cIdx} className="py-3 px-4 text-sm">
                      <div className="h-4 w-3/4 rounded bg-gray-300"></div>
                    </td>
                  ))}
                </tr>
              ))
              : rows.length > 0 ? rows.map((row, idx) => (
                <tr
                  key={idx}
                  className="transition-colors duration-200 hover:bg-gray-50"
                >
                  {columns.map((col, cIdx) => {
                    const cellContent = row[col] ?? "-";
                    const cellClass = getCellClass(col);

                    return (
                      <td key={cIdx} className={`border-b border-gray-200 px-4 py-3 align-middle ${cellClass}`}>
                        {cellContent}
                      </td>
                    );
                  })}
                </tr>
              )) : (
                <tr>
                  <td colSpan={columns.length} className="px-4 py-8 text-center text-sm text-gray-500 font-fig-normal">
                    No results found
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClaimsDataTable;
